import { OnboardingStep } from '@teetsh/app/src/containers/Livrets/types/onboardingStep';

const livretsUrls = {
  root: 'livrets',
  new: () => `${livretsUrls.root}/new`,
  newStep: (step: OnboardingStep) => `${livretsUrls.new()}/${step}`,
  configPeriodes: (mode: 'new' | 'edit') =>
    `${livretsUrls.root}/config-periodes?mode=${mode}`,
  livretEleve: () => livretsUrls,
  livretDetails: (id: string) => `${livretsUrls.root}/${id}`,
  livretEleveDetails: (id: string, eleveId: string) =>
    `${livretsUrls.livretDetails(id)}/eleves/${eleveId}`,
  livretConfig: (id: string) => `${livretsUrls.livretDetails(id)}/config`,
};

export default livretsUrls;
